import type { AiCostsParams, InfraWindow, UserFillsParams, UsersListParams } from './adminTypes';
import type { ComplianceAlertsParams, ComplianceOverviewParams, ComplianceUsersParams } from './complianceTypes';

export const queryKeys = {
  /** Everything of the Compliance console nests under `['admin','compliance']` so one invalidation sweeps it. */
  complianceAlerts: (params: ComplianceAlertsParams) => ['admin', 'compliance', 'alerts', params] as const,
  complianceAlert:  (id: string) => ['admin', 'compliance', 'alert', id] as const,
  complianceOverview: (params: ComplianceOverviewParams = {}) => ['admin', 'compliance', 'overview', params] as const,
  complianceUsers:  (params: ComplianceUsersParams) => ['admin', 'compliance', 'users', params] as const,
  complianceUser:   (id: string) => ['admin', 'compliance', 'user', id] as const,
  complianceFindTraders: (params: UsersListParams) => ['admin', 'compliance', 'find-traders', params] as const,
  capabilities: () => ['admin', 'capabilities'] as const,
  dashboard:  (from: string, to: string) => ['admin', 'dashboard', { from, to }] as const,
  users:      (params: UsersListParams)  => ['admin', 'users', params] as const,
  userDetail: (id: string, from: string, to: string, accounts: readonly string[]) =>
    ['admin', 'user', id, { from, to, accounts }] as const,
  /** Nested under the user key so a user-scoped invalidation sweeps the fill pages too. */
  userFills: (userId: string, params: UserFillsParams) =>
    ['admin', 'user', userId, 'fills', params] as const,
  /** Nested under the user key so a user-scoped invalidation sweeps the chat too. */
  strategyChat: (userId: string, strategyId: string) =>
    ['admin', 'user', userId, 'chat', strategyId] as const,
  aiCosts:    (params: AiCostsParams)    => ['admin', 'ai', params] as const,
  infra:        () => ['admin', 'infra'] as const,
  infraMetrics: (window: InfraWindow) => ['admin', 'infra', 'metrics', window] as const,
  plans:        () => ['admin', 'plans'] as const,
  planStripePrices: (tier: string) => ['admin', 'plans', tier, 'stripe-prices'] as const,
  creditPacks:  () => ['admin', 'credit-packs'] as const,
} as const;
